import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, a tela de dar acesso aos apps e pedir MFA pede o
// `powerapps:manage` (`powerapps#update`, `powerapp_accesses#*`).

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/powerapps'),
      meta: {
        permissions: ['administrator'],
        escopos: ['powerapps:manage'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'POWERAPPS_SETTINGS.TITLE',
        icon: 'i-lucide-layout-grid',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'powerapps_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
            escopos: ['powerapps:manage'],
          },
        },
      ],
    },
  ],
};
